module.exports = __webpack_public_path__ + "img/yz.b4e562df.png";